module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp12_9005.1e727e53.png";